import { render, staticRenderFns } from "./instructions_text_only.vue?vue&type=template&id=81627264&scoped=true&"
import script from "./instructions_text_only.vue?vue&type=script&lang=js&"
export * from "./instructions_text_only.vue?vue&type=script&lang=js&"
import style0 from "./instructions_text_only.vue?vue&type=style&index=0&id=81627264&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81627264",
  null
  
)

export default component.exports